
import { useState } from "react";
import { Table, TableBody } from "@/components/ui/table";
import { AdminUsersListProps } from "./types";
import { UserTableHeader } from "./UserTableHeader";
import { UserTableRow } from "./UserTableRow";
import { UsersPagination } from "./UsersPagination";
import { useAdminUsers } from "@/hooks/useAdminUsers";

export const AdminUsersList = ({ search }: AdminUsersListProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const { users, loading, totalPages, handleDeleteUser } = useAdminUsers({
    search,
    currentPage,
    itemsPerPage
  });

  if (loading) {
    return <div>Loading users...</div>;
  }

  return (
    <div className="space-y-4">
      <Table>
        <UserTableHeader />
        <TableBody>
          {users.map((user) => (
            <UserTableRow
              key={user.id}
              user={user}
              onDeleteUser={handleDeleteUser}
            />
          ))}
        </TableBody>
      </Table>
      <UsersPagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
      />
    </div>
  );
};

